<template>
  <div class="top-statistics-area">
    <div class="title-2" style="margin-bottom: 15px">班主任反馈原因</div>
    <a-tabs v-model="activeTabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
        <a-row :gutter="20" type="flex">
          <a-col :span="10">
            <div class="abnormal-feedback">
              <div class="flex-align-center">
                <!--时间标签-->
                <div class="flex-align-center tag-list">
                  <div
                    v-for="(tag, index) in timeTagList"
                    :key="index"
                    :class="{ 'list-tag-item': true, 'active-tag': tagIndex == index }"
                    @click="handleTagClick(index)"
                  >
                    {{ tag }}
                  </div>
                </div>
                <a-range-picker
                  v-model="dateRange"
                  :allow-clear="false"
                  :getCalendarContainer="(node) => node.parentNode"
                  style="width: 220px; margin: 0 15px"
                  @change="handleDateChange"
                />
                <a-button icon="search" type="primary" @click="query">查询</a-button>
              </div>
              <!--柱状图区域-->
              <div style="height: 310px; margin-top: 10px">
                <BaseChart
                  v-if="option.series[0].data && option.series[0].data.length > 0"
                  :option="option"
                  :loading="chartLoading"
                  ref="baseChartRef"
                  style="height: 300px"
                />
                <EmptyData
                  v-else
                  :loading="chartLoading"
                  :styleObj="{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }"
                />
              </div>
            </div>
          </a-col>
          <a-col :span="14">
            <!--右侧简易表格-->
            <a-table
              class="simple-table"
              :columns="simpleColumns"
              :dataSource="localTableData"
              :loading="tableLoading"
              :pagination="ipagination"
              size="small"
              :scroll="{ x: 1000, y: 285 }"
              style="height: 346px"
              :customHeaderRow="
                () => ({ style: { height: '42px', background: 'rgba(244, 247, 250, 1)' } })
              "
              :customRow="() => ({ style: { height: '42px' } })"
              @change="handleTableChange"
            >
              <!-- <template slot="operation" slot-scope="text, record">
                <a @click="$emit('viewDetail', record, activeTabKey, dateRange)">查看详情</a>
              </template> -->
            </a-table>
          </a-col>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { formatYearMonthDate, getMonthDateRange, getWeekDateRange } from '@/utils/date'
import { getSchoolTerm } from '@/utils/termDate'
import BaseChart from '@/components/echartZyz/components/BaseChart.vue'
import { getAction } from '@api/manage'
import EmptyData from '@/components/EmptyData'
export default {
  name: 'AbnormalFeedback',
  components: {
    BaseChart,
    EmptyData,
  },
  props: {
    tabPaneConfig: {
      type: Array,
      default: () => [],
    },
    // 如果父组件不再传入 dataSource，我们可以优先使用组件内的 localTableData
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTabKey: 1,
      chartLoading: false,
      tableLoading: false,
      baseChartRef: null,
      timeTagList: ['上周', '本月', '本学期'],
      tagIndex: 0,
      dateRange: [],
      selectedReason: null, // 当前选中的反馈原因（用于过滤表格）
      localTableData: [], // 表格数据
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
      },
      simpleColumns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
          width: 60,
          customRender: (_, record, index) => index + 1,
        },
        { title: '姓名', dataIndex: 'studentName', width: 100, align: 'center'},
        { title: '班级', dataIndex: 'className', width: 150, align: 'center' },
        { title: '班主任', dataIndex: 'headTeacherName', width: 100, align: 'center' },
        { title: '反馈原因', dataIndex: 'reason', width: 150, align: 'center' },
        { title: '备注', dataIndex: 'remark', width: 200, align: 'center' },
        { title: '反馈时间', dataIndex: 'feedbackTime', width: 160, align: 'center' },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   align: 'center',
        //   width: 100,
        //   fixed: 'right',
        //   scopedSlots: { customRender: 'operation' },
        // },
      ],
      option: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          top: '15%',
          containLabel: true,
        },
        yAxis: [
          {
            type: 'value',
            minInterval: 1,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#E8E8E8',
              },
            },
          },
        ],
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#E8E8E8',
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: '#666',
              margin: 15,
            },
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        series: [
          {
            type: 'bar',
            barWidth: 30,
            data: [],
            label: {
              show: true,
              position: 'top',
              color: '#666',
              fontSize: 12,
              formatter: '{c}',
            },
            itemStyle: {
              color: (params) => {
                const colors = [
                  '#FA9602',
                  '#EE6D6D',
                  '#4ED9B1',
                  '#E542DD',
                  '#5442EF',
                  '#12B999',
                  '#1790FF',
                ]
                return colors[params.dataIndex % colors.length]
              },
              borderRadius: [4, 4, 0, 0],
            },
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            startValue: 0,
            endValue: 9,
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
          },
        ],
      },
    }
  },
  watch: {
    tagIndex: {
      handler(val) {
        if (val == -1) return
        const { startDate, endDate } = getSchoolTerm()
        const dateRangObj = {
          0: getWeekDateRange(-1), // 上周日期范围
          1: getMonthDateRange(), // 本月日期范围
          2: [startDate, endDate], // 本学期日期范围
        }
        this.dateRange = dateRangObj[val]
        this.query()
      },
      immediate: true,
    },
    activeTabKey: {
      handler() {
        this.query()
        // 方案优化：切换 Tab 后，DOM 可能需要重新渲染，确保在渲染完成后绑定事件
        this.$nextTick(() => {
          this.initClickEvent()
        })
      },
    },
    chartLoading: {
      handler(val) {
        this.$nextTick(() => {
          const chartRefs = this.$refs.baseChartRef
          if (!chartRefs) return
          const refs = Array.isArray(chartRefs) ? chartRefs : [chartRefs]
          refs.forEach((ref) => {
            if (val) {
              ref.showLoading?.()
            } else {
              ref.hideLoading?.()
            }
          })
        })
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initClickEvent()
    })
  },
  methods: {
    handleTabChange(key) {
      this.activeTabKey = key
    },
    handleTagClick(index) {
      this.tagIndex = index
    },
    handleDateChange(dates) {
      this.tagIndex = -1
      this.dateRange = dates
    },

    handleTableChange(pagination) {
      this.ipagination.current = pagination.current
      this.ipagination.pageSize = pagination.pageSize
      this.getFeedbackStudentList()
    },

    initClickEvent() {
      // 获取图表组件引用，注意 v-for 中的 ref 是数组
      const chartRefs = this.$refs.baseChartRef
      if (!chartRefs) return

      const refs = Array.isArray(chartRefs) ? chartRefs : [chartRefs]
      refs.forEach((ref) => {
        // 访问 mixin 中定义的 chartInstance
        const instance = ref?.chartInstance
        if (instance) {
          // 1. 监听整个画布的点击 (包含空白区域)
          instance.getZr().off('click') // 先解绑，防止重复
          instance.getZr().on('click', (params) => {
            const pointInPixel = [params.offsetX, params.offsetY]
            // 判断点击位置是否在坐标系内
            if (instance.containPixel('grid', pointInPixel)) {
              // 获取点击位置对应的 x 轴索引
              const xIndex = instance.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
              // 获取 x 轴的数据 (注意 option.xAxis 是数组)
              const xData = this.option.xAxis[0].data
              if (xData && xData[xIndex]) {
                this.barClick({ name: xData[xIndex] })
              }
            }
          })

          // 2. 监听鼠标移动，改变指针样式
          instance.getZr().off('mousemove')
          instance.getZr().on('mousemove', (params) => {
            const pointInPixel = [params.offsetX, params.offsetY]
            if (instance.containPixel('grid', pointInPixel)) {
              instance.getZr().setCursorStyle('pointer')
            } else {
              instance.getZr().setCursorStyle('default')
            }
          })
        }
      })
    },

    barClick(params) {
      console.log('柱状图点击数据：', params)
      // 如果点击的是当前已选中的，则取消选中（恢复显示全部）
      if (this.selectedReason === params.name) {
        return
      } else {
        this.selectedReason = params.name
      }

      this.getFeedbackStudentList()
    },

    async query() {
      // 切换 Tab 或点击查询时，重置图表选中状态，但保留筛选条件
      this.selectedReason = null
      this.chartLoading = true

      const dateRangeObj = {
        beginDate: this.dateRange?.[0] && formatYearMonthDate(this.dateRange[0]),
        endDate: this.dateRange?.[1] && formatYearMonthDate(this.dateRange[1]),
        type: this.activeTabKey,
      }
      try {
        const { success, result } = await getAction(
          '/statisticV2/getClassTeacherFeedback',
          dateRangeObj
        )
        if (success) {
          const { reasonNameList, reasonValueList } = result
          this.$set(this.option.xAxis[0], 'data', reasonNameList)
          this.$set(this.option.series[0], 'data', reasonValueList)

          // 联动获取右侧列表数据
          this.getFeedbackStudentList()

          // 数据更新后，图表会重新渲染，确保事件绑定依然有效
          this.$nextTick(() => {
            this.initClickEvent()
          })
        }
      } finally {
        this.chartLoading = false
      }
    },

    async getFeedbackStudentList() {
      this.tableLoading = true
      const params = {
        beginDate: this.dateRange?.[0] && formatYearMonthDate(this.dateRange[0]),
        endDate: this.dateRange?.[1] && formatYearMonthDate(this.dateRange[1]),
        type: this.activeTabKey,
        reason: this.selectedReason || '', // 如果没选则传空，获取全部
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      }
      try {
        const { success, result } = await getAction('/statisticV2/getFeedbackStudentList', params)
        if (success) {
          // 兼容处理：如果是分页结构则取 records，如果是数组则直接赋值
          this.localTableData = result.records || result || []
          this.ipagination.total = result.total || 0
        }
      } finally {
        this.tableLoading = false
      }
    },
  },
}
</script>

<style scoped lang="less">
.top-statistics-area {
  padding: 20px;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e8e8e8;

  /deep/ .simple-table {
    .ant-table-thead > tr > th {
      background: rgba(244, 247, 250, 1) !important;
      font-size: 12px;
      color: rgba(0, 0, 0, 1);
    }
    .ant-table-placeholder {
      border: 0;
      padding: 75px 0;
    }
    .ant-table-header {
      background: rgba(244, 247, 250, 1);
      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        background: rgba(244, 247, 250, 1);
      }
    }
    .ant-table-body {
      &::-webkit-scrollbar {
        width: 8px;
        background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #ccc;
      }
    }
    table {
      table-layout: fixed;
    }
  }
}

.abnormal-feedback {
  background-color: #ffffff;
  border-radius: 10px;
  .tag-list {
    .list-tag-item {
      width: 54px;
      height: 24px;
      margin: 6px;
      line-height: 24px;
      text-align: center;
      background: #eff4fc;
      border-radius: 4px;
      color: #404040;
      font-size: 12px;
      cursor: pointer;
    }
    .active-tag {
      background: #009dff;
      color: #fff;
    }
  }
}

.title-2 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
</style>
